import { useIntl } from 'react-intl';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router';
import { Alert } from '@rossum/ui/material';
import { RulesExecutionLogsGuard } from '../../components/Restrictors';
import { ActivitiesPage as ExtensionLogsPage } from '../../features/extensions/pages/activities';
import { extensionsActivitiesPath } from '../../features/extensions/routes';
import { useExtensionLogsFeatureSubscription } from '../../features/pricing/hooks/useExtensionsFeatureSubscription';
import { RulesExecutionLogsPage } from '../../features/rules-execution-logs';
import { boldText } from '../../lib/formaterValues';
import { ActivitiesHeader } from './ActivitiesHeader';
import {
  activitiesExtensionsPath,
  activitiesPath,
  activitiesRulesPath,
} from './routes';

type LocationState = {
  redirectedFromExtensions?: boolean;
};

export const ActivitiesPage = () => {
  const intl = useIntl();
  const location = useLocation<LocationState>();
  const { replace } = useHistory();
  const showRedirectAlert = location.state?.redirectedFromExtensions;

  const logsSubscription = useExtensionLogsFeatureSubscription();

  return (
    <Switch>
      <Route
        path={activitiesExtensionsPath()}
        render={() => (
          <ExtensionLogsPage
            HeaderComponent={ActivitiesHeader}
            alert={
              showRedirectAlert ? (
                <Alert
                  severity="info"
                  onClose={() =>
                    replace({
                      ...location,
                      state: {
                        ...location.state,
                        redirectedFromExtensions: undefined,
                      },
                    })
                  }
                >
                  {intl.formatMessage(
                    {
                      id: 'features.activities.movedToSettings',
                    },
                    {
                      oldPath: extensionsActivitiesPath(),
                      boldText,
                    }
                  )}
                </Alert>
              ) : null
            }
          />
        )}
      />
      <Route
        path={activitiesRulesPath()}
        render={() => (
          <RulesExecutionLogsGuard>
            <RulesExecutionLogsPage HeaderComponent={ActivitiesHeader} />
          </RulesExecutionLogsGuard>
        )}
      />
      <Redirect
        from={activitiesPath()}
        to={
          logsSubscription.canAccess
            ? activitiesExtensionsPath()
            : activitiesRulesPath()
        }
      />
    </Switch>
  );
};
